import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadUser } from '../../redux/actions/users'

const BetaReadOnlyBanner = () => {
  const dispatch = useDispatch()
  const { user, isAuthenticated } = useSelector(state => state.users)
  const participant = isAuthenticated && user?.betaParticipant
  useEffect(() => {
    if (!participant) return
    const refresh = () => dispatch(loadUser())
    window.addEventListener('focus', refresh)
    return () => window.removeEventListener('focus', refresh)
  }, [dispatch, participant])
  if (!isAuthenticated || !user?.betaReadOnly) return null
  return (
    <div className='alert alert-warning text-center mb-0' role='status'>
      You are viewing the previous Fit Kit Studio in read-only mode.{' '}
      <a href='https://beta.fitkitstudio.com'>Make changes in the new Fit Kit Studio.</a>
    </div>
  )
}

export default BetaReadOnlyBanner
